import {combineReducers} from 'redux'
import createSdbReducer from './sdb/reducer'
import createPtoReducer from './pto/reducer'

export default (initAppData) => {
    return combineReducers({
        sdbBalance: createSdbReducer(initAppData),
        ptoBalance: createPtoReducer(initAppData)
    })
}



// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/commonReducer.js